import { NotificationTypesEnum } from "@/model/data/enums/NotificationTypesEnum";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetTotalNotReadNotificationsResData extends ApiGenericResponse {
    unreadNotifications: Map<string, number> = null;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.UnreadNotifications) {
            this.unreadNotifications = new Map<string, number>();
            for (let key in obj.UnreadNotifications) {
                if (Object.values(NotificationTypesEnum).includes(key)) this.unreadNotifications.set(key, Number(obj.UnreadNotifications[key]));
            }
        }
    }
}
